import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useGetAllGetOrderListHistoryQuery,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useAdminChangeStatusMutation,
} from "../../../Api/attoDeskApi";
import {
  IOrderItemEdit,
  IOrderList,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import { useParams } from "react-router-dom";
import { OrderListStatus, SizeOfLevelType } from "../../../Core/Enum/enum";
import LogoMain from "../../../Images/logo.webp";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useFormik } from "formik";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "ManagerConfirmed":
      return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderItemEdit[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch: orderListRefetch,
  } = useGetAllGetOrderListHistoryQuery({
    orderId: String(orderListHistoryId),
    searchText: "",
  });
  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newStatus, { isLoading }] = useAdminChangeStatusMutation();

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderItemEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name} - ${category.username}`);
    });
    return map;
  }, [userList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;

  const handleExportToExcel = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const exportData = orderList.map((row, index) => ({
      Items: row.variantName || "",
      Qty: `${row.productTotalUnit} ${convertUnit(row.variantUnit)}`,
      Remark: row.remark || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrderList");
    const fileName = `OrderList_${dayjs(createAt).format("YYYY MMM, DD")}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const tableData = orderList.map((row, index) => [
      row.variantName || "",
      `${row.productTotalUnit} ${convertUnit(row.variantUnit)}`,
      row.remark || "",
    ]);

    const tableHeaders = [["Items", "Qty", "Remark"]];

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 12;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 10;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);
      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      rightAlignText(`Order List :  ${ReDateId}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(
        `Create By: ${userMap2.get(createBy) || ""}, ${dayjs(createAt).format(
          "YYYY MMM, DD"
        )}`,
        textStartY + 5
      );

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [200, 200, 200],
          textColor: 0,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.1,
      });

      const fileName = `OrderList_${dayjs(createAt).format(
        "YYYY MMM, DD"
      )}.pdf`;

      doc.save(fileName);
    };
  };

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const handleOpenStatusPopup = () => {
    setCoursingToStatus(String(orderListHistoryId));
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(undefined);
    setOpen(false);
  };

  const handleOpenDialogGenerate = () => {
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(orderListHistoryId),
          status: values.status,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();

  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
        navigate("/order/list");
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  if (orderListIsLoading || OrderListDateIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Card className={classes.quotesCard}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2} alignItems="center" py={5}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Button
                      startIcon={<TableViewIcon />}
                      className={classes.addButtonPdfExcel}
                      onClick={handleExportToExcel}
                    >
                      Excel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      startIcon={<LocalPrintshopSharpIcon />}
                      className={classes.addButtonPdfExcel}
                      onClick={handleExportToPDF}
                    >
                      pdf
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      variant="contained"
                      className={classes.addButton}
                      onClick={() => {
                        const path =
                          orderListStatus === "OrderListCreated"
                            ? `/order/list/edit/${orderListHistoryId}`
                            : `/order/list/sentToManager/edit/${orderListHistoryId}`;

                        navigate(path);
                      }}
                    >
                      Edit
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={6} mb={2}>
            <Grid container>
              <img
                src={LogoMain}
                alt="AttoDesk Login"
                style={{
                  width: "200px",
                  height: "60px",
                  display: "block",
                }}
              />
            </Grid>
          </Grid>

          <Grid item lg={8} md={6} sm={6} xs={6} mb={2}>
            <Typography
              variant="subtitle1"
              textAlign={"right"}
              className={classes.cardTitle256}
            >
              Order List : {ReDateId}
            </Typography>
            <Typography textAlign={"right"}>
              {"Create By : "}
              {userMap.get(createBy) || ""}
            </Typography>
            <Typography textAlign={"right"}>
              {"Create At : "}
              {dayjs(createAt).format("YYYY-MM-D hh:mm A") || ""}
            </Typography>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container justifyContent={"space-between"} spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                      textAlign={"right"}
                      className={classes.primaryHeading}
                    >
                      {convertStatus(orderListStatus || "")}
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                            {/* <TableCell className={classes.tablheader} sx={{width: "5%"}}>
                            <strong>#</strong>
                          </TableCell> */}
                            <TableCell className={classes.tablheader}>
                              <strong>Items</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>Qty</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>Remark</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orderListIsLoading ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  height="10vh"
                                >
                                  <CircularProgress />
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : orderListIsError ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                Some thing went to wron
                              </TableCell>
                            </TableRow>
                          ) : orderList.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                No data available
                              </TableCell>
                            </TableRow>
                          ) : (
                            orderList.map((row: IOrderItemEdit, index) => (
                              <TableRow
                                key={index}
                                className={classes.tableRowHover}
                                // sx={{
                                //   backgroundColor: row.isPreviousPaymentPaid
                                //     ? "#f79aa61c"
                                //     : "transparent",
                                // }}
                              >
                                {/* <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {page * rowsPerPage + index + 1}
                              </TableCell> */}
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.variantName}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.productTotalUnit}{" "}
                                  {convertUnit(row.variantUnit)}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.remark}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
              <Grid item>
                <Button
                  startIcon={<CheckCircleOutlineIcon />}
                  variant="contained"
                  className={classes.addButton}
                  onClick={() => {
                    if (orderListStatus === "OrderListCreated") {
                      handleOpenStatusPopup();
                    } else {
                      handleOpenDialogGenerate();
                    }
                  }}
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {coursingToStatus && (
            <StatusPopup
              open={open}
              handleCloseDelete={handleCloseStatusPopup}
              onConfirm={async () => {
                await handleChangeStatus(String(orderListHistoryId).toString());
              }}
              title="Confirm Status Change"
              content={`Are you sure you want to change the status to "Manager Approval Pending"? 
            Once updated, this action cannot be undone. 
            Order ID: ${ReDateId}`}
            />
          )}

          <Dialog
            open={openOrderListDate}
            onClose={handleCloseDialogGenerate}
            sx={{ padding: 5, minWidth: 450 }}
          >
            <Grid className={classes.Dialog}>
              <form onSubmit={formik.handleSubmit}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Confirm Action
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent>
                  <DialogContentText sx={{ pt: 3 }}>Status</DialogContentText>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={1}>
                      <TextField
                        select
                        size="small"
                        className={classes.textField}
                        SelectProps={{
                          native: false,
                        }}
                        defaultValue=""
                        InputLabelProps={{ shrink: true }}
                        {...formik.getFieldProps("status")}
                      >
                        <MenuItem value="" disabled>
                          Select some option
                        </MenuItem>

                        {Object.entries(OrderListStatus).map(
                          ([key, value], index) => (
                            <MenuItem key={index} value={value}>
                              {convertStatus(key)}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={handleCloseDialogGenerate}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>

                  <Button
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.addButton}
                    onClick={() => formik.handleSubmit()}
                    disabled={!formValid || isLoading}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </form>
            </Grid>
          </Dialog>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
